<template>
  <div class="course-tab-title">{{ title }}</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.course-tab-title {
  width: 100%;
  height: 46px;
  box-sizing: border-box;
  color: #333;
  font-family: MFYuanHeiNoncommercial, MFYuanHeiNoncommercial-lv,
    MFYuanHeiNoncommercial-lb, MFYuanHeiNoncommercial-4;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-left: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
